import { get } from "../../../utils/objectHelpers";

$ {
    const text = get(input, "text", null);
    const image = get(input, "image", null);
}

<if(text && image)>
    $ {
        const variant = !!input.isSmall ? "modal" : "_mini";
        delete text.action;
    }
    <span class="str-eek-tire">
        <str-textual-display ...text class="str-eek-tire__text" />
        <ebay-infotip variant=variant>
            <@content>
                <str-image ...image useUrl=true loading="lazy" />
            </@content>
        </ebay-infotip>
    </span>
</if>
